import type { ReactNode } from "react";
import Toolbar from "@imminently/decisively-ui/Toolbar";

export interface MonitorTableToolbarProps {
  title: string;
  actions?: ReactNode;
}

export const MonitorTableToolbar = ({ title, actions }: MonitorTableToolbarProps) => (
  <Toolbar className="border-b border-border bg-background">
    <div className="text-base font-semibold truncate">{title}</div>
    <Toolbar.FillSpace />
    {actions ? <Toolbar.Group className="gap-2">{actions}</Toolbar.Group> : null}
  </Toolbar>
);
